export default function FullPageLoader({ show }) {
  // Do not block UI unless explicitly requested
  if (!show) return null;

  return (
    <div
      aria-busy="true"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(255, 255, 255, 0.7)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div className="full-page-loader-spinner" />

      <style>{`
        .full-page-loader-spinner {
          width: 55px;
          height: 55px;
          border: 5px solid rgba(0,0,0,0.2);
          border-top-color: #0d6efd;
          border-radius: 50%;
          animation: fullPageSpin 0.7s linear infinite;
        }

        @keyframes fullPageSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
